// gsap is a global from PHP-enqueued vendor scripts

export function initMouseHoverAnimation() {
    document.querySelectorAll(".outline").forEach((link) => {
        const underline = link.querySelector(".underline");
        if (!underline) return;

        link.tl = gsap.timeline({ paused: true });

        link.tl.fromTo(
            underline,
            { width: "0%", left: "0%" },
            { width: "100%", duration: 0.5 }
        );

        link.tl.add("midway");

        link.tl.fromTo(
            underline,
            { width: "100%", left: "0%" },
            { width: "0%", left: "100%", duration: 1, immediateRender: false }
        );

        link.addEventListener("mouseenter", () => link.tl.tweenFromTo(0, "midway"));
        link.addEventListener("mouseleave", () => link.tl.play());
    });
}
